import styled from 'styled-components';

const SkillsPageContainer = styled.div`
    padding-top: var(--section-padding);
    padding-bottom: var(--section-padding);
    .container {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        & > div {
            @media (min-width: 992px) {
                flex-basis: 45%;
            }
            & > h3 {
                margin: 0 0 30px;
                font-weight: normal;
                text-align: center;
                text-transform: uppercase;
            }
            & > p {
                color: #777;
                line-height: 2;
                text-align: center;
                margin-bottom: 60px;
            }
        }
    }
    .testimonials .bullets {
        display: flex;
        justify-content: center;
        margin-top: 50px;
        margin-bottom: 50px;
        li {
            width: 14px;
            height: 14px;
            border: 1px solid #aaa;
            border-radius: 50%;
            margin-right: 10px;
            cursor: pointer;
            &.active {
                background-color: var(--main-color);
                border-color: var(--main-color);
            }
        }
    }
`;

export default SkillsPageContainer;
